import { render, staticRenderFns } from "./BaseItemCompetition.vue?vue&type=template&id=d0e4d7d0&scoped=true&"
import script from "./BaseItemCompetition.vue?vue&type=script&lang=js&"
export * from "./BaseItemCompetition.vue?vue&type=script&lang=js&"
import style0 from "./BaseItemCompetition.vue?vue&type=style&index=0&id=d0e4d7d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0e4d7d0",
  null
  
)

export default component.exports